import { ActionModalController } from './Modals/ActionModalController'
import { EndExamModalController } from './Modals/EndExamModalController'
import { IModalConstructor } from './Modal'
import { RejectOrSkipModalController } from './Modals/RejectOrSkipModalController'
import { SubmitModalController } from './Modals/SubmitModalController'
import { ViolationsModalController } from './Modals/ViolationsModalController'
import { SaveForLaterModalController } from './Modals/SaveForLaterModalController'
import { InactivityModalController } from './Modals/InactivityModalController'

const BuiltInModals: IModalConstructor<unknown>[] = [
    SubmitModalController as unknown as IModalConstructor<unknown>,
    ActionModalController as unknown as IModalConstructor<unknown>,
    ViolationsModalController as unknown as IModalConstructor<unknown>,
    RejectOrSkipModalController as unknown as IModalConstructor<unknown>,
    EndExamModalController as unknown as IModalConstructor<unknown>,
    SaveForLaterModalController as unknown as IModalConstructor<unknown>,
    InactivityModalController as unknown as IModalConstructor<unknown>,
] as const

export class ModalRegistry {
    private modals: Map<string, IModalConstructor<unknown>> = new Map()
    private static instance: ModalRegistry | null = null
    private constructor() {
        this.registerBuiltInModals()
    }

    static getInstance() {
        if (!ModalRegistry.instance) {
            ModalRegistry.instance = new ModalRegistry()
        }
        return ModalRegistry.instance
    }

    getModal(id: string) {
        return this.modals.get(id)
    }

    registerModal(modal: IModalConstructor<unknown>) {
        this.modals.set(modal.Id, modal)
    }

    unregisterModal(id: string) {
        this.modals.delete(id)
    }

    registerBuiltInModals() {
        BuiltInModals.forEach(modal => this.registerModal(modal))
    }
}
